import axios from 'axios';

// Cliente público (SIN interceptor de auth): el portal de onboarding no tiene sesión.
const publicClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

export interface OnboardInvitation {
  platform: 'ganamos' | 'casinozeus' | 'kingbox' | 'soyjoker';
  slug: string;
  displayName: string;
  status: string;
  expiresAt: string;
}
export interface WaStartResult { instance: string; status?: string }
export interface WaQrResult { status: string; qr: string | null }
export interface WaStatusResult { connected: boolean; status: string }

export type OnboardCreds =
  | { username: string; password: string }
  | { alias: string; password: string; company: string; db?: number };

export interface CompleteBody {
  creds: OnboardCreds;
  waInstance?: string | null;
  /** Login del panel que eligió el cliente; el backend crea el Operator (rol master). */
  operator: { username: string; password: string };
  siteUrl?: string;
}
export interface CompleteResult { tenantId: string; slug: string }

export const onboardApi = {
  validate: async (token: string): Promise<OnboardInvitation> => {
    const { data } = await publicClient.get(`/onboard/${token}`);
    return data as OnboardInvitation;
  },
  waStart: async (token: string): Promise<WaStartResult> => {
    const { data } = await publicClient.post(`/onboard/${token}/wa/start`);
    return data as WaStartResult;
  },
  waQr: async (token: string): Promise<WaQrResult> => {
    const { data } = await publicClient.get(`/onboard/${token}/wa/qr`);
    return data as WaQrResult;
  },
  waStatus: async (token: string): Promise<WaStatusResult> => {
    const { data } = await publicClient.get(`/onboard/${token}/wa/status`);
    return data as WaStatusResult;
  },
  complete: async (token: string, body: CompleteBody): Promise<CompleteResult> => {
    const { data } = await publicClient.post(`/onboard/${token}/complete`, body);
    return data as CompleteResult;
  },
};
